import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../../../guards/authenticated.guard';
import { SchoolDetailViewPageComponent } from './view.page';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: SchoolDetailViewPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class SchoolDetailViewPageRoutingModule {}
